const sectionCardReview02Css = `
[data-type='section-card-review-02'] .card-review-wrapper {
  padding-block: 40px;
  color: var(--text-color, #ffffff);
  background-color: var(--background-color, #3cb54b);
}

[data-type='section-card-review-02'] .card-review-container {
  padding: 16px;
  display: flex;
  gap: 32px;
}

[data-type='section-card-review-02'] .card-review-container[data-position='left'] {
  flex-direction: row;
}

[data-type='section-card-review-02'] .card-review-container[data-position='right'] {
  flex-direction: row-reverse;
}

[data-type='section-card-review-02'] .card-review-container .card-review-left {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

[data-type='section-card-review-02'] .card-review-container .card-review-left .card-review-image {
  max-width: 400px;
  width: 100%;
}

[data-type='section-card-review-02'] .card-review-container .card-review-left .card-review-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 12px;
}

[data-type='section-card-review-02'] .card-review-container .card-review-right {
  flex: 1;
}

[data-type='section-card-review-02'] .card-review-container .card-review-right .card-review-wrap-stars {
  display: flex;
  align-items: center;
  gap: 4px;
  color: #c4c4c4;
  margin-bottom: 16px !important;
}

[data-type='section-card-review-02'] .card-review-container .card-review-right .card-review-wrap-stars svg {
  fill: #c4c4c4;
  width: 16px;
  height: 16px;
  transition: all 0.2s ease;
}

[data-type='section-card-review-02'] .card-review-container .card-review-right .card-review-wrap-stars[data-full-stars='1'] svg:nth-child(-n + 2),
[data-type='section-card-review-02'] .card-review-container .card-review-right .card-review-wrap-stars[data-full-stars='1.0'] svg:nth-child(-n + 2),
[data-type='section-card-review-02'] .card-review-container .card-review-right .card-review-wrap-stars[data-full-stars='2'] svg:nth-child(-n + 3),
[data-type='section-card-review-02'] .card-review-container .card-review-right .card-review-wrap-stars[data-full-stars='2.0'] svg:nth-child(-n + 3),
[data-type='section-card-review-02'] .card-review-container .card-review-right .card-review-wrap-stars[data-full-stars='3'] svg:nth-child(-n + 4),
[data-type='section-card-review-02'] .card-review-container .card-review-right .card-review-wrap-stars[data-full-stars='3.0'] svg:nth-child(-n + 4),
[data-type='section-card-review-02'] .card-review-container .card-review-right .card-review-wrap-stars[data-full-stars='4'] svg:nth-child(-n + 5),
[data-type='section-card-review-02'] .card-review-container .card-review-right .card-review-wrap-stars[data-full-stars='4.0'] svg:nth-child(-n + 5),
[data-type='section-card-review-02'] .card-review-container .card-review-right .card-review-wrap-stars[data-full-stars='5'] svg:nth-child(-n + 6),
[data-type='section-card-review-02'] .card-review-container .card-review-right .card-review-wrap-stars[data-full-stars='5.0'] svg:nth-child(-n + 6) {
  color: #f0b100;
  fill: #f0b100;
}

[data-type='section-card-review-02'] .card-review-container .card-review-right .card-review-wrap-stars[data-half-star='1'] svg:nth-child(2),
[data-type='section-card-review-02'] .card-review-container .card-review-right .card-review-wrap-stars[data-half-star='1.0'] svg:nth-child(2),
[data-type='section-card-review-02'] .card-review-container .card-review-right .card-review-wrap-stars[data-half-star='2'] svg:nth-child(3),
[data-type='section-card-review-02'] .card-review-container .card-review-right .card-review-wrap-stars[data-half-star='2.0'] svg:nth-child(3),
[data-type='section-card-review-02'] .card-review-container .card-review-right .card-review-wrap-stars[data-half-star='3'] svg:nth-child(4),
[data-type='section-card-review-02'] .card-review-container .card-review-right .card-review-wrap-stars[data-half-star='3.0'] svg:nth-child(4),
[data-type='section-card-review-02'] .card-review-container .card-review-right .card-review-wrap-stars[data-half-star='4'] svg:nth-child(5),
[data-type='section-card-review-02'] .card-review-container .card-review-right .card-review-wrap-stars[data-half-star='4.0'] svg:nth-child(5),
[data-type='section-card-review-02'] .card-review-container .card-review-right .card-review-wrap-stars[data-half-star='5'] svg:nth-child(6),
[data-type='section-card-review-02'] .card-review-container .card-review-right .card-review-wrap-stars[data-half-star='5.0'] svg:nth-child(6) {
  stroke: #f0b100;
  fill: url(#half-star-gradient-infinite);
}

[data-type='section-card-review-02'] .card-review-container .card-review-right .card-review-wrap-stars .card-review-rating-text {
  font-size: 14px;
  color: var(--text-color, #ffffff);
  margin: 0 0 0 4px !important;
  font-weight: 500 !important;
}

[data-type='section-card-review-02'] .card-review-container .card-review-right .card-review-content h1,
[data-type='section-card-review-02'] .card-review-container .card-review-right .card-review-content h2,
[data-type='section-card-review-02'] .card-review-container .card-review-right .card-review-content h3 {
  font-size: 36px;
  line-height: normal;
  margin: 0 0 16px 0 !important;
}

[data-type='section-card-review-02'] .card-review-container .card-review-right .card-review-content p {
  font-size: 16px;
  margin-bottom: 12px !important;
}

[data-type='section-card-review-02'] .card-review-container .card-review-right .card-review-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

[data-type='section-card-review-02'] .card-review-container .card-review-right .card-review-list .card-review-item {
  display: flex;
  align-items: center;
  gap: 16px;
}

[data-type='section-card-review-02'] .card-review-container .card-review-right .card-review-list .card-review-item .card-review-item-image {
  width: 32px;
  height: 32px;
  overflow: hidden;
}

[data-type='section-card-review-02'] .card-review-container .card-review-right .card-review-list .card-review-item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

[data-type='section-card-review-02'] .card-review-container .card-review-right .card-review-list .card-review-item .card-review-item-text {
  flex: 1;
}

[data-type='section-card-review-02'] .card-review-container .card-review-right .card-review-list .card-review-item .card-review-item-text h1,
[data-type='section-card-review-02'] .card-review-container .card-review-right .card-review-list .card-review-item .card-review-item-text h2,
[data-type='section-card-review-02'] .card-review-container .card-review-right .card-review-list .card-review-item .card-review-item-text h3 {
  font-size: 24px;
  line-height: normal;
  margin: 0 0 12px 0 !important;
}

[data-type='section-card-review-02'] .card-review-container .card-review-right .card-review-list .card-review-item .card-review-item-text p {
  font-size: 16px;
  margin-bottom: 4px !important;
}

[data-type='section-card-review-02'] .card-review-container .card-review-right .card-review-list .card-review-item .card-review-item-text p:last-child {
  margin-bottom: 0 !important;
}

[data-type='section-card-review-02'] .card-review-button-container {
  min-width: 400px;
  width: 100%;
  width: fit-content;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 20px;
}

[data-type='section-card-review-02'] .card-review-button-container .card-review-button {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--button-background-color, #facc15);
  border-radius: 24px;
  padding: 16px;
  color: var(--button-text-color, #000000);
  margin-top: 20px !important;
  line-height: normal;
  font-size: 18px;
  font-weight: 700;
  text-decoration: none;
  width: 100%;
  gap: 12px;
  cursor: pointer;
  text-transform: uppercase;
  text-align: center;
  border: 2px solid var(--button-icon-background, #eab308);
  animation: button-glow-pulse 1.725s cubic-bezier(0.4, 0, 0.2, 1) infinite;
  position: relative;
}

[data-type='section-card-review-02'] .card-review-button-container .card-review-button:hover {
  opacity: 0.8;
}

@keyframes button-glow-pulse {
  0% {
    box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.1);
  }
  50% {
    box-shadow: 0 0 0 5px rgba(255, 255, 255, 0.7);
  }
  100% {
    box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.1);
  }
}

[data-type='section-card-review-02'] .card-review-button-container .card-review-button .card-review-button-arrow {
  width: 30px;
  height: 30px;
  background-color: var(--button-icon-background, #eab308);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

[data-type='section-card-review-02'] .card-review-button-container .card-review-button .card-review-button-arrow svg {
  width: 20px;
  height: 20px;
}

[data-type='section-card-review-02'] .card-review-button-container .card-review-footer {
  font-weight: 500 !important;
}

[data-type='section-card-review-02'] .card-review-button-container .card-review-footer h1,
[data-type='section-card-review-02'] .card-review-button-container .card-review-footer h2,
[data-type='section-card-review-02'] .card-review-button-container .card-review-footer h3 {
  font-size: 16px;
  line-height: normal;
  margin: 0 0 16px 0 !important;
}

[data-type='section-card-review-02'] .card-review-button-container .card-review-footer p {
  font-size: 14px;
  margin-bottom: 12px !important;
}

[data-type='section-card-review-02'] .card-review-button-container.desktop {
  display: flex;
}

[data-type='section-card-review-02'] .card-review-button-container.mobile {
  display: none;
}

@container (max-width: 768px) {
  [data-type='section-card-review-02'] .card-review-wrapper {
    padding-block: 16px;
  }

  [data-type='section-card-review-02'] .card-review-container {
    padding: 8px;
  }

  [data-type='section-card-review-02'] .card-review-container[data-position='left'],
  [data-type='section-card-review-02'] .card-review-container[data-position='right'] {
    flex-direction: column-reverse;
  }

  [data-type='section-card-review-02'] .card-review-container .card-review-left .card-review-image {
    max-width: 100%;
  }

  [data-type='section-card-review-02'] .card-review-container .card-review-right .card-review-content h1,
  [data-type='section-card-review-02'] .card-review-container .card-review-right .card-review-content h2,
  [data-type='section-card-review-02'] .card-review-container .card-review-right .card-review-content h3 {
    font-size: 24px;
  }

  [data-type='section-card-review-02'] .card-review-container .card-review-right .card-review-content p {
    font-size: 14px;
  }

  [data-type='section-card-review-02'] .card-review-container .card-review-right .card-review-list .card-review-item {
    font-size: 14px;
  }

  [data-type='section-card-review-02'] .card-review-container .card-review-right .card-review-list .card-review-item .card-review-item-text h1,
  [data-type='section-card-review-02'] .card-review-container .card-review-right .card-review-list .card-review-item .card-review-item-text h2,
  [data-type='section-card-review-02'] .card-review-container .card-review-right .card-review-list .card-review-item .card-review-item-text h3 {
    font-size: 20px;
    line-height: 24px;
  }

  [data-type='section-card-review-02'] .card-review-container .card-review-right .card-review-list .card-review-item .card-review-item-text p {
    font-size: 14px;
  }

  [data-type='section-card-review-02'] .card-review-button-container {
    min-width: auto;
    width: 100%;
  }

  [data-type='section-card-review-02'] .card-review-button-container .card-review-button {
    width: fit-content;
  }

  [data-type='section-card-review-02'] .card-review-button-container .card-review-footer h1,
  [data-type='section-card-review-02'] .card-review-button-container .card-review-footer h2,
  [data-type='section-card-review-02'] .card-review-button-container .card-review-footer h3 {
    font-size: 14px;
  }

  [data-type='section-card-review-02'] .card-review-button-container.desktop {
    display: none;
  }

  [data-type='section-card-review-02'] .card-review-button-container.mobile {
    display: flex;
  }
}
`;
export default sectionCardReview02Css;
